<template>
  <div class="product-detail-card mt-2">
    <div class="d-flex align-center">
      <div>
        <v-avatar class="product-farm-card-face-img" width="100%" color="grey">
          <img v-if="farm.image && farm.image.image_url" :src="farm.image.image_url">
          <v-icon v-else dark>mdi-account-circle</v-icon>
        </v-avatar>
      </div>
      <div class="pl-2">
        <div class="product-name ga-shop-products-detail-link-to-farm">
          <router-link :to="`/shop/farms/${farm.id}`">{{ farm.name }}({{ farm.locations[0].prefecture }})</router-link>
        </div>
        <v-btn color="#007e57" outlined @click="goTo" class="ga-shop-products-detail-link-to-conversation">
          {{ $t("send_message_to_farm") }}
          <v-icon right dark>mdi-chat</v-icon>
        </v-btn>
        <div class="my-2 text-caption">
          ※メッセージを送る際は、品種名を生産者にお伝えください。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    farm: {
      type: Object,
      required: true
    },
    goToConversation: {
      type: Function,
      require: false
    }
  },
  methods: {
    goTo () {
      this.goToConversation();
    }
  }
};
</script>

<style lang="scss" scoped>
.product-detail-card {
  border: #0000001f 1px solid;
  border-radius: 5px;
  background-color: #fff;
  padding: 8px 16px;
  overflow: hidden;

  @media screen and (max-width: 960px) {
    min-height: 0;
  }
}

.product {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto auto;
  grid-auto-flow: column;
  justify-content: space-between;
  white-space: nowrap;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 4px;
  margin-bottom: 16px;

  .name {
    grid-column: span 2;
    flex: auto;
    color: #333;
    font-weight: bold;
    font-size: 32px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .arrival {
    font-size: 12px;
    color: #555;
  }

  .average {
    justify-self: end;
    margin-left: 24px;
    font-size: 14px;
    color: #777;
  }

  .number {
    justify-self: end;
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }

  .unit {
    font-size: 14px;
    font-weight: normal;
  }

  .day {
    font-size: 14px;
  }
}

.product-name {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
}

.product-name-md {
  font-family: Roboto;
  font-weight: bold;
  font-size: 16px;
  color: #555555;
}

.product-date {
  font-weight: bold;
  font-size: 16px;
  color: #555555;
}

.product-name-lg {
  font-weight: bold;
  font-size: 20px;
}

.product-green-container {
  width: 76px;
  height: 28px;
  background: #00796b;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}

.product-delivery-note {
  padding: 8px;
  background: #eeeeee;

  font-weight: 500;
  font-size: 14px;

  color: #01579b;
}

.nowrap {
  white-space: nowrap;
}

.product-farm-card {
  &-face {
    &-img {
      width: 4rem !important;
      height: 4rem !important;
      img {
        object-fit: cover;
      }
    }
  }
}
</style>
